module.exports = __webpack_public_path__ + "media/images/redesign-images/ffa/design-tile-images/design-tile-10-8cac6a5c5a5c52a748eae62ff565af52.webp";